import Core from './Core';
import ErrorManager from './ErrorManager';

class Merger
{
    static Instance = new Merger();

    Do(main, concerned)
    {
        return new Promise((resolve, reject) => {
            let client = concerned[main]; // On prend comme base le client choisi
            delete concerned[main];
            delete client["nature"];
            delete client["conseilor"];

            concerned.forEach((entry) => { // on fusionne les informations fusionnables
                if(entry == null)
                    return;
                if(client.phone == null)
                    client.phone = entry.phone;
                else if(entry.phone != null)
                {
                    let phones = entry.phone.split(";");
                    phones.forEach(function(phone){
                        if(client.phone.indexOf(phone.trim()) === -1){
                            client.phone += " ; "+phone.trim();
                        }
                    });
                }

                if(client.phone_mobile == null)
                    client.phone_mobile = entry.phone_mobile;
                else if(entry.phone_mobile != null)
                {
                    let phones_mobile = entry.phone_mobile.split(";");
                    phones_mobile.forEach(function(phone_mobile){
                        if(client.phone_mobile.indexOf(phone_mobile.trim()) === -1){
                            client.phone_mobile += " ; "+phone_mobile.trim();
                        }
                    });
                }

                if(client.email == null)
                    client.email = entry.email;
                else if(entry.email != null)
                {
                    let emails = entry.email.split(";");
                    emails.forEach(function(email){
                        if(client.email.indexOf(email.trim()) === -1){
                            client.email += " ; "+email.trim();
                        }
                    });
                }
            });
           
            Core.Instance.Request(Core.Address+"Client/"+client.id, client, "PUT")
            .then((json) =>{
                return Promise.all([
                        this.UpdateLinks("APV", client.id, concerned),
                        this.UpdateLinks("Car", client.id, concerned),
                        this.UpdateLinks("Opinion", client.id, concerned),
                        this.UpdateLinks("Relation", client.id, concerned),
                    ]
                );
            })
            .then(() => {
                return this.ResolveCarConflict(client);
            })
            .then(() => {
                return this.DeleteClients(concerned);
            })
            .then(() => {
                resolve(client);
            })
            .catch((error)=> {
                ErrorManager.Instance.Handle(error, false);
                reject(error);
            })
        });

    }

    DeleteClients(concerned)
    {
        return Promise.all(
            concerned.map((client) =>{
                if(client == null)
                    return Promise.resolve(null);
                return Core.Instance.Request(Core.Address+"Client/"+client.id, null, "DELETE");
            })
        );  
    }

    async ResolveCarConflict(client)
    {
        let to_delete = [];
        let json = await Core.Instance.Request(Core.Address+"Car/Client_id/"+client.id, null, "GET");
        let cars = json == null ? [] : json;

        for(let i = 0; i < cars.length; i++)
        {
            for(let u = 0; u < cars.length; u++)
            {
                if( i == u || cars[i] == null || cars[u] == null)
                    continue;

                let self_code = cars[i].code == null ? null : cars[i].code.toUpperCase().trim(); 
                let other_code = cars[u].code == null ? null : cars[u].code.toUpperCase().trim();
                if(self_code != null && self_code.length <= 0)
                    self_code = null;
                if(other_code != null && other_code.length <= 0)
                    other_code = null;

                let self_vin = cars[i].vin == null ? null : cars[i].vin.toUpperCase().trim(); 
                let other_vin = cars[u].vin == null ? null : cars[u].vin.toUpperCase().trim();
                if(self_vin != null && self_vin.length <= 0)
                    self_vin = null;
                if(other_vin != null && other_vin.length <= 0)
                    other_vin = null;

                if(other_code != self_code && other_vin != self_vin)
                    continue;

                // fusion
                let keys = Object.keys(cars[i]);
                for(let key in keys)
                {
                    key = keys[key];
                    if(cars[i][key] == null || cars[i][key].toString().trim().length <= 0)
                        cars[i][key] = cars[u][key];
                }

                let self_km = cars[i]["km"] == null ? 0 : parseInt(cars[i]["km"]);
                let other_km = cars[u]["km"] == null ? 0 : parseInt(cars[u]["km"]);

                if(other_km > self_km)
                    cars[i]["km"] = other_km;

                // Suppression 
                to_delete.push(cars[u]);
                cars[u] = null;
            }
        }

        //Suppression des voitures fusionnées 
        for(let car in to_delete)
        {
            car = to_delete[car];
            await Core.Instance.Request(Core.Address+"Car/"+car.id, null, "DELETE");
        }

        for(let car in cars)
        {
            car = cars[car];
            if(car != null){
                await Core.Instance.Request(Core.Address+"Car/"+car.id, car, "PUT");
            }
        }
    }

    UpdateLinks(table, final_id, concerned)
    {
        return new Promise((resolve, reject) => {
            Promise.all(
                concerned.map((c) => {
                    if(c == null)
                        return Promise.resolve(null);
                    return Core.Instance.Request(Core.Address+table+"/Client_id/"+c.id, null, "GET")
                })
            )
            .then((data) =>{
                let requests = [];
                data.forEach((apvs) => {
                    if(apvs == null)
                    {
                        return;
                    }
                    apvs.forEach((apv) => {
                        apv.Client_id = final_id;
                        requests.push(
                            Core.Instance.Request(Core.Address+table+"/"+apv.id, apv, "PUT")
                        );
                    });
                });
                return Promise.all(requests);
            })
            .then((json) => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            })
        });
    }

}

export default Merger;


// WEBPACK FOOTER //
// ./src/Core/Merger.js